import styled from './modallogo.module.css'
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';


function ModalLogo() {
    const { setIsOpenL } = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    //const [image, setImage] = useState([{name:'',size:0,preview:''}]);
    const [upload,setUpload] = useState();
   



    function closeModal() {
        setIsOpenL(false);
    }

    const dragEvents = {
        onDragEnter: (e) => {
            e.preventDefault()
        },
        onDragLeave: (e) => {
            e.preventDefault()
        },
        onDragOver: (e) => {
            e.preventDefault()
        },
        onDrop: (e) => {
            e.preventDefault()
            
            const data = new FileReader();
            data.addEventListener('load',()=>{
               setUpload(data.result);
            }) 
            
            data.readAsDataURL(e.dataTransfer.files[0]);
            
            /*const files = Array.from(e.dataTransfer.files);
            const images = files.map((file)=>{
               const {name, size} =file;
               return {name,size,preview:URL.createObjectURL(file)}
            });
            setImage(images);*/   
        }
    };


    async function PutImage(){

        let dados = {
            cgccli: cgccli,
            image:upload
        }
        
        
        await api.post(`info/upload`,dados)
        .then((response)=>{
           if(!response.data.msg){
             closeModal();
           }else{
             Alerta('Erro',response.data.msg,'error')
             closeModal();
           }
        }).catch((erro)=>{
            Alerta('Erro',erro,'error')
            closeModal();
        })
    }

    return (

        <div className={styled.modal}>
            
            <div className={styled.modalcontent}>
                <div className={styled.dragdrop} {...dragEvents}>
                    <a>Arraste a imagem aqui</a>
                </div>
                <img src={upload} className={styled.img}/>
            </div>
            <div className={styled.modalfooter} onClick={()=>PutImage()}>
                SALVAR
            </div>
        </div>
    )
}

export default ModalLogo;